import React, { useCallback, useEffect, useReducer, useState } from 'react'
import ReactGA from 'react-ga'
import { useParams } from 'react-router-dom'
import { parseISO, format as formatDate } from 'date-fns'
import { Admin as API } from '@gta/portaali-connector-api'

import Header from 'components/header'
import Carousel from 'components/carousel'
import ProgressIndicator from 'components/progress-indicator'

import GlobalContextProvider from 'hooks/useGlobalContext'

import reducer, { initialState } from './state'

ReactGA.initialize(process.env.REACT_APP_GA_ID)
ReactGA.pageview('/offerts')

const OffertsPage = () => {
  const { format } = useParams()
  const [state, dispatch] = useReducer(reducer, initialState)
  
  const [formatedEndDate, setFormatedEndDate] = useState('')
  const [formatedStartDate, setFormatedStartDate] = useState('')

  const getBrochures = useCallback(
    async () => {
      dispatch({ type: 'BROCHURES_CHANGE_LOADING', loading: true })
      dispatch({ type: 'BROCHURES_CLEAR' })

      try {
        const response = await API.offertsGetBrochure({ format })

        const { code, brochure } = response.data

        if (code === 'SUCCESS_BROCHURE_RETRIEVED') {
          dispatch({
            type: 'BROCHURE_ADD',
            brochure,
          })

          setFormatedEndDate(
            formatDate(parseISO(brochure.endDate), 'dd/MM/yyyy')
          )
          setFormatedStartDate(
            formatDate(parseISO(brochure.startDate), 'dd/MM/yyyy')
          )
        }
      } catch (err) {
      }

      dispatch({ type: 'BROCHURES_CHANGE_LOADING', loading: false })
    },
    [format]
  )

  useEffect(() => {
    let gtaFormat

    switch (format) {
      case '4':
        gtaFormat = 'MSF'
        break;
      case '5':
        gtaFormat = 'SDB'
        break;
      default:
        gtaFormat = 'SUMA'
    }

    ReactGA.event({
      category: 'Ofertas',
      action: 'Ver Folleto de Ofertas',
      value: gtaFormat,
      label: gtaFormat,
    })
  }, [format])

  useEffect(() => {
    getBrochures()
  }, [getBrochures])

  return (
    <GlobalContextProvider value={{ ...state, dispatch }}>
      {state.loading ? (
        <ProgressIndicator />
      ) : (
        <>
          <Header init={formatedStartDate} end={formatedEndDate} />

          <Carousel />
        </>
      )}
    </GlobalContextProvider>
  )
}

export default OffertsPage
